module.exports = __webpack_public_path__ + "img/pamas.1189d15a.jpg";